import { useState, useCallback, useRef, useEffect } from "react";

import fetchWrapper from "../../lib/apiCall";

export default function useTriggeredAPICall() {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);
  const activeSerialRef = useRef(0);

  const fetchData = useCallback(
    async (
      apiEndpoint,
      method = "GET",
      body = null,
      additionalHeaders = {}
    ) => {
      abortControllerRef.current?.abort();

      const serial = ++activeSerialRef.current;
      const controller = new AbortController();
      abortControllerRef.current = controller;
      const requestSignal = controller.signal;

      setIsLoading(true);
      setError(null);
      setData(null);

      try {
        const result = await fetchWrapper.apiCall(
          apiEndpoint,
          method,
          body,
          additionalHeaders,
          requestSignal,
          true
        );

        if (serial !== activeSerialRef.current) {
          return result;
        }
        setData(result);
        return result;
      } catch (err) {
        if (serial !== activeSerialRef.current) {
          return undefined;
        }
        if (!requestSignal.aborted) {
          setError(err);
          throw err;
        }
        return undefined;
      } finally {
        if (serial === activeSerialRef.current) {
          setIsLoading(false);
        }
      }
    },
    []
  );

  return { fetchData, data, isLoading, error };
}
